import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";


//import Form from 'views/Ibs/Form'
import List from 'views/Ibs/List'
import IbWizard from 'views/Ibs/Wizard/IbWizard'

//import IbWizard from 'views/Forms/Wizard'

class Ibs extends React.Component {
  render() {
    const {match}=this.props;
    return (

          <Switch>
            <Route path={`${match.path}/add`} component={IbWizard}/>
            <Route path={`${match.path}/:id`} component={IbWizard}/>
            {/* <Route path={`${match.path}/add`} component={Form}/> */}
            {/* <Route path={`${match.path}/:id`} component={Form}/> */}
            <Route component={List}/>
          </Switch>

    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(Ibs);



// WEBPACK FOOTER //
// ./src/views/Ibs/Ibs.jsx